<template>
  <div class="home">
    <div class="home_logo"></div>
    <div class="home_swiper">
      <swiper :options="swiperOptions" ref="mySwiper">
        <!-- 轮播内容，使用 v-for 动态渲染 -->
        <swiper-slide v-for="(item, index) in slideList" :key="index">
          <img :src="item.imgUrl" alt="" />
        </swiper-slide>
        <!-- 如果开启了分页器，需要添加这个 slot -->
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- 如果开启了导航按钮，需要添加这两个 slot -->
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
      </swiper>
    </div>
    <div class="home_contentImg">
      <div class="home_contentImg_x"></div>
      <div class="home_contentImg_img">
        <img :src="imgUrl + '/005.png'" alt="" />
      </div>
      <div class="home_contentImg_x"></div>
    </div>
    <div class="home_title">防伪验真查询</div>
    <div class="home_scan" @click="scan">
      <div class="home_scan_img">
        <img :src="imgUrl + '/006.png'" alt="" />
      </div>
      <div class="home_scan_text">点击扫码查询</div>
    </div>
    <div class="home_titleText">查询方法</div>
    <div class="home_text">
      <div>方法一：手机打开NFC功能，贴近产品包装盒背面封口处防伪标签</div>
      <div>方法二：手机打开定位功能，刮开黑色二维码标签涂层，扫码查询</div>
      <div>*aphranel®优法兰™产品仅供中国大陆地区售卖</div>
    </div>
    <div class="home_prop" v-if="errorMsg">
      <div class="home_prop_toast">
      请扫描正确的防伪码
    </div>
    </div>
    
  </div>
</template>

<script>
import axios from "axios";
import config from "../config";
// 引入 vConsole
import VConsole from "vconsole";
// 引入 Swiper 组件和对应的样式
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css"; // 注意：这里是 swiper 的样式，不是 vue-awesome-swiper

export default {
  name: "home",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      isScan: false,
      imgUrl:
        "https://release-res-buk-cdn-1318200227.cos.ap-shanghai.myqcloud.com/sup8-ui/2.0/custom/sup8-h5-app-moyang",
      // 模拟的图片数据
      slideList: [
        {
          imgUrl:
            "https://release-res-buk-cdn-1318200227.cos.ap-shanghai.myqcloud.com/sup8-ui/2.0/custom/sup8-h5-app-moyang/003.png",
        },
        {
          imgUrl:
            "https://release-res-buk-cdn-1318200227.cos.ap-shanghai.myqcloud.com/sup8-ui/2.0/custom/sup8-h5-app-moyang/004.png",
        },
      ],
      // Swiper 的配置项 (与官方 Swiper 5 文档一致)
      swiperOptions: {
        loop: true, // 循环模式
        autoplay: {
          // 自动播放
          delay: 3000,
          disableOnInteraction: false, // 用户操作后不停止自动播放
        },
        pagination: {
          // 分页器配置
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          // 前进后退按钮配置
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 你还可以根据需要添加其他配置，如 slidesPerView, spaceBetween 等
      },
      errorMsg:false
    };
  },
  mounted() {
    // 初始化 vConsole
    // this.vConsole = new VConsole();
    // 获取 swiper 实例，注意这里的写法
    const swiperInstance = this.$refs.mySwiper.$swiper;
    console.log("Swiper 实例:", swiperInstance);
    this.setWx();
  },
  methods: {
    scan() {
      var that = this;
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList: ["scanQRCode"],
          success: function (res) {
            if (res.checkResult.scanQRCode === true) {
              wx.scanQRCode({
                needResult: 1,
                scanType: ["qrCode"],
                success: function (res) {
                  const result = res.resultStr;
                  if (
                    result.indexOf("fath5v2.yesno.com.cn") != -1 ||
                    result.indexOf("m.cj8.ren") != -1 ||
                    result.indexOf("shmy.ccn.ren") != -1 ||
                    result.indexOf("mysw.ccn.ren") != -1
                  ) {
                    window.location.href = result;
                  } else {
                    that.errorMsg = true;
                    setTimeout(()=>{
                      that.errorMsg = false;
                    },2000)
                  }
                },
                fail: function (res) {
                  console.log("fail", res);
                },
              });
            } else {
              console.log("抱歉，当前用户端版本不支持扫一扫，请升级到最新版");
            }
          },
          fail: function (res) {
            console.log("fail", res);
          },
        });
      });
    },
    setWx() {
      if (!window.wx) {
        console.error("wx 对象未加载，请检查 jweixin.js 是否正确引入");
        return;
      }
      console.log("window.wx", window.wx);
      console.log("config", config);
      let apiUrl = "";
      let enterpriseNo=''
      if (
        window.location.origin.indexOf("10.20.26.29") != "-1" ||
        window.location.origin.indexOf("fath5v2.yesno.com.cn") != "-1"
      ) {
        apiUrl = "https://api-fat.yesno.com.cn";
        enterpriseNo='142954025040'
      } else {
        apiUrl = "https://restapi.supercarrier8.com";
        enterpriseNo='132949688718'
      }
      let params = {
        url: window.location.href,
        enterpriseNo: enterpriseNo,
        appId: "",
      };
      axios
        .get(`${apiUrl}/marketing/wechat-sdk/v1/get-wechat-js-sdk`, {
          params,
        })
        .then((res) => {
          console.log("res", res.data);
          const { appId, nonceStr, signature, timestamp } = res.data.data || {};
          console.log(
            "appId, nonceStr, signature, timestamp",
            appId,
            nonceStr,
            signature,
            timestamp,
          );
          wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            // 添加分享所需的 JS 接口
            jsApiList: [
              "scanQRCode",
              "updateAppMessageShareData",
              "updateTimelineShareData",
            ],
          });
        })
        .catch((error) => {
          console.error("获取微信 SDK 配置失败", error);
        });
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  height: 100%;
  display: block;
}
.home {
  background: url("https://release-res-buk-cdn-1318200227.cos.ap-shanghai.myqcloud.com/sup8-ui/2.0/custom/sup8-h5-app-moyang/000.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  padding-top: 30px;
  min-height: 100vh;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.home_logo {
  width: 97px;
  height: 66px;
  background: url("https://release-res-buk-cdn-1318200227.cos.ap-shanghai.myqcloud.com/sup8-ui/2.0/custom/sup8-h5-app-moyang/001.png");
  background-size: 100% 100%;
  margin: 0 auto;
  margin-bottom: 26px;
}
.home_swiper {
  width: 308px;
  height: 164px;
  margin: 0 auto;
  margin-bottom: 30px;
  border-radius: 10px;
  overflow: hidden;
}
.home_contentImg {
  width: 308px;
  height: 36px;
  margin: 0 auto;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.home_contentImg_x {
  width: 102px;
  height: 1px;
  background: #fff;
}
.home_contentImg_img {
  width: 39px;
  height: 36px;
}
.home_title {
  font-size: 28px;
  font-family: SourceHanSerif-bold;
  color: #454c79;
  text-align: center;
  margin-bottom: 30px;
}
.home_scan {
  width: 265px;
  height: 44px;
  margin: 0 auto;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(170, 210, 183, 1) 99%
  );
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.home_scan_img {
  width: 24px;
  height: 24px;
}
.home_scan_text {
  font-size: 16px;
  color: #454c79;
  margin-left: 10px;
}
.home_titleText {
  font-size: 18px;
  text-align: center;
  margin-bottom: 16px;
  color: #454c79;
}
.home_text {
  /* padding: 0 10px;
  box-sizing: border-box; */
  font-size: 12px;
  text-align: center;
  color: #454c79;
  line-height: 1.6;
}
/* 示例：设置轮播图容器高度，让图片自适应 */
.swiper-container-wrap {
  width: 100%;
  height: 300px;
}
.swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/* 分页器自定义样式 */
.swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
}
.swiper-pagination-bullet-active {
  width: 10px;
  height: 10px;
  background: #333;
  opacity: 1;
}
.home_prop{
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
}
.home_prop_toast{
  width: 200px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  /* background: rgba(0,0,0,0.5); */
  background: #000;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
}
</style>
